<template>
    <div class="row wrap">
        <div class="col-6">
            <input-text v-model="label.x_coord" :label="$t('Coord X')" after="px" @change="label.save()"/>
        </div>
        <div class="col-6">
            <input-text v-model="label.y_coord" :label="$t('Coord Y')" after="px" @change="label.save()"/>
        </div>
        <div class="col-12">
            <input-text v-model="label.text" :label="$t('Text')" @change="label.save()" ref="text"/>
        </div>
        <div class="col-12">
            <Pointer_Edit :label="label"/>
        </div>
    </div>
</template>

<script>
    import InputText from "@/modules/input/input-text";
    import Pointer_Edit from "@/modules/labels/Pointer_Edit";
    import {label} from "@/class/label";

    export default {
        name: "Texts_Edit",
        components: {Pointer_Edit, InputText},
        props: {
            label: {type: Object, default:() => new label()}
        },
        mounted() {
            if(this.label.isNew()) {
                this.$refs.text.focusInput()
                this.$refs.text.selectInput()
            }
        }
    }
</script>